import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import {CommonModule, DatePipe} from '@angular/common';
import {CardModule} from 'primeng/card';
import {RadioButtonModule} from 'primeng/radiobutton';
import { PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalModule, MsalService, MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from '../environments/environment';


import {AppComponent} from './app.component';
import {JobsComponent} from './jobs/jobs.component';


import {JobsService} from './services/jobs.service';
import {ResourcesService} from './services/resource.service';
import {DeviceDetectorService } from 'ngx-device-detector';
import {SideBarComponent} from "./side-bar/side-bar.component";
import {RobotDashboardComponent} from "./robot-dashboard/robot-dashboard.component";
import {ActiveJobsComponent} from './active-jobs/active-jobs.component';
import {NewJobDetailsComponent} from "./new-job-details/new-job-details.component";
import {UserIdService} from './services/user-id.service';
import {AuthenticationGuard} from './oauth/authentication.guard';
import {OauthTokenGuard} from './oauth/oauth-token.guard';
import {AutoCompleteModule} from 'primeng/autocomplete';
import {MultiSelectModule} from 'primeng/multiselect';
import {FieldsetModule} from 'primeng/fieldset';
import {DropdownModule} from 'primeng/dropdown';
import {DialogModule} from 'primeng/dialog';
import {ChartModule} from 'primeng/chart';
import {CalendarModule} from 'primeng/calendar';
import {ButtonModule} from 'primeng/button';
import {ProgressBarModule} from 'primeng/progressbar';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {TooltipModule} from 'primeng/tooltip';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {JobDetailsComponent} from './job-details/job-details.component';
import {AppRoutingModule} from './/app-routing.module';
import {httpInterceptorProviders} from './http-interceptor';
import {Error404Component} from './error-404/error-404.component';
import {LoginComponent} from './oauth/login.component';
import {SharedDataService} from './services/shared-data.service';
import {StorageService} from './services/storage.service';
import {ArticleService} from './services/article.service';
import {SafeHtmlPipe} from '../safe-html';
import {ExecutionsComponent} from './executions/executions.component';
import {TableModule} from 'primeng/table';
import {StepsModule} from 'primeng/steps';
import {BusinessComponent} from './business/business.component';
import {SelectButtonModule} from 'primeng/selectbutton';
import {CdkTableModule} from '@angular/cdk/table';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatSliderModule} from '@angular/material/slider';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {ExecutionDetailsComponent} from './execution-details/execution-details.component';
import {ViewLogsComponent} from './view-logs/view-logs.component';
import { JoblogviewComponent } from './joblogview/joblogview.component';
import {ToastModule} from "primeng/toast";
import { MessageService } from 'primeng/api';

// MSAL logger callback
export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log('[MSAL]', message);
}

@NgModule({
  exports: [
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    ExecutionDetailsComponent,
    TooltipModule,
    ToastModule,
  ],
  declarations: [ExecutionDetailsComponent, JoblogviewComponent],
  imports: [
    CommonModule,
    ProgressSpinnerModule,
    FieldsetModule,
    ChartModule,
    ButtonModule,
    TooltipModule,
    ToastModule,
    CdkTableModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
  ]
})
export class DemoMaterialModule {}

@NgModule({ declarations: [
        AppComponent,
        JobsComponent,
        JobDetailsComponent,
        Error404Component,
        SafeHtmlPipe,
        ExecutionsComponent,
        BusinessComponent,
        RobotDashboardComponent,
        SideBarComponent,
        ActiveJobsComponent,
        NewJobDetailsComponent,
        LoginComponent,
        ViewLogsComponent,
    ],
    bootstrap: [AppComponent, MsalRedirectComponent], imports: [BrowserModule,
        FormsModule,
        TableModule,
        ButtonModule,
        RadioButtonModule,
        DropdownModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        // ✅ Initialize MSAL with forRoot
        MsalModule.forRoot(
            // MSAL Instance Configuration
            new PublicClientApplication({
                auth: {
                    clientId: environment.msalConfig.auth.clientId,
                    authority: environment.msalConfig.auth.authority,
                    redirectUri: environment.msalConfig.auth.redirectUri,
                    postLogoutRedirectUri: environment.msalConfig.auth.redirectUri,
                    navigateToLoginRequestUrl: true
                },
                cache: {
                    cacheLocation: BrowserCacheLocation.SessionStorage,
                    storeAuthStateInCookie: true
                },
                system: {
                    loggerOptions: {
                        loggerCallback,
                        logLevel: LogLevel.Info,
                        piiLoggingEnabled: false
                    }
                }
            }),
            // MSAL Guard Configuration
            {
                interactionType: InteractionType.Redirect,
                authRequest: {
                    scopes: [...environment.apiConfig.scopes]
                },
                loginFailedRoute: '/login'
            },
            // MSAL Interceptor Configuration
            {
                interactionType: InteractionType.Redirect,
                protectedResourceMap: new Map<string, Array<string>>([
                    [environment.apiConfig.uri, environment.apiConfig.scopes]
                ])
            }
        ),
       // DataListModule,
        ChartModule,
        FieldsetModule,
        ProgressBarModule,
        ProgressSpinnerModule,
        AutoCompleteModule,
        DialogModule,
        TableModule,
        CalendarModule,
        StepsModule,
        FormsModule,
        ReactiveFormsModule,
        SelectButtonModule,
        CardModule,
        MultiSelectModule,
        DemoMaterialModule], providers: [JobsService, DatePipe, ResourcesService, DeviceDetectorService,
        httpInterceptorProviders, SharedDataService, MessageService,
        AuthenticationGuard, StorageService, ArticleService, UserIdService, OauthTokenGuard, RobotDashboardComponent,
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: true } },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MsalInterceptor,
          multi: true
        },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        provideHttpClient(withInterceptorsFromDi())] })
export class AppModule {

}
